import { makeAutoObservable, reaction } from "mobx";
import { IRootStore } from "./RootStore";
import EmsService from "../services/ems/ems.service";
import { IEmsResponse } from "../services/ems/typings/IEmsResponse";
import { IMedicalEmergencyApiResponse } from "../services/medical-emergency/typings/IMedicalEmergencyApiResponse";
import MedicalEmergencyService from "../services/medical-emergency/medical-emergency.service";
import { PassengerType } from "../services/passenger/typings/PassengerType";
import VideocallResponseType from "../services/videocall/typings/VideocallResponseType";
import { EventApiResponseType } from "../services/events/typings/EventApiResponseType";
import IFlightResponse from "../services/flights/typings/IFlightResponse";
import { MedicalEmergencyWithPassengerType } from "../services/medical-emergency/typings/MedicalEmergencyWithPassengerType";
import { OrganizationType } from "../components/main/body/screens/IAM/Users/types/OrganizationType";

interface ReportIndicatorType {
    glucoMeter: boolean;
    bloodPressure: boolean;
    oxiMeter: boolean;
    aed: boolean;
}

interface ReportImageStateType {
    showImage: boolean,
    imageUrl: string
}

interface DialogBoxType {
    showConfirmation: boolean,
    showLoginPrompt: boolean
}

interface crewChat {
    height: number,
    width: number
}

interface captainChat {
    height: number,
    width: number
}

interface initiateMedicalShow {
    showSymptoms: boolean,
    filterEnable: boolean
}

interface notificationForStatus {
    notificationTitle: string | null,
    notificationMessage: string | null
}

interface passengerQuestion {
    question: string,
    response: string | null
}

interface singlePassengerDetail {
    id: number;
    name: string | null;
    contactNumber: string | null;
    email: string | null;
    address: string | null;
    gender: string | null;
    chronicDisease:string | null;
    physicallyDisabled:string | null;
    age: string | null;
    dob: string | null;
    ordId:string | null;
    onlineStatus: boolean;
    passengerStatusQuestions?: passengerQuestion[]
}

export class EmsStore {
    networkStatus: boolean = true;
    newEmergency: number = 1;
    path: any[] = [];
    activeTab: number = 0;
    searchValue: string = "";
    assignToMeModal: boolean = false;
    assignToSomeoneModal: boolean = false;
    showAssignModal: boolean = false;
    EmsList: IEmsResponse[] = [];
    emsSearchString: string = "";
    selectedEmsId: string = "";
    searchEmsList: string = "";
    emergencyStatusFilter: string = "";
    medicalEmergencies: IMedicalEmergencyApiResponse[] = [];
    selectedMedicalIdList: { [id: number]: boolean } = {};
    selectedMedicalIdListEms: { [id: number]: boolean } = {};
    passengerIdNameMapState: Map<string, any> = new Map();
    flightRoom: string = "";
    notes: string = "";
    allNotes = {
         subjective: "",
         objective: "",
         assesment: "",
         plain: "",
         Attachment: ""
        };
    activeNotes: number | null = null;
    flightId: string = "";
    onlineStatus: boolean = false;
    diversion: string = "";
    flightLanded: boolean = false;
    pageRefresh: number = 0;
    medicalKitRefresh: number = 0;
    passenger: PassengerType | null = null;
    responsiveState: {showEmergencyDetails: boolean} = {showEmergencyDetails: true}
    reportIndicator: ReportIndicatorType = {
        glucoMeter: false,
        bloodPressure: false,
        oxiMeter: false,
        aed: false
    };
    allReportList = [];
    filterReportList = [];
    historyPageReportList = [];
    reportImageState: ReportImageStateType = {
        showImage: false,
        imageUrl: "",
      };
    chatImageState: ReportImageStateType = {
    showImage: false,
    imageUrl: "",
    };
    reportHistoryImageState: ReportImageStateType = {
    showImage: false,
    imageUrl: "",
    };
    
    dialogState: DialogBoxType = {
        showConfirmation: false,
        showLoginPrompt: false,
      };
    videocallRecord: VideocallResponseType | null = null;
    event: EventApiResponseType[] = [];
    flightRecord: IFlightResponse | null = null;
    reportCardTopM: number = 0;

    crewVideoIcon: boolean = false;
    crewAudioIcon: boolean = false;
    crewExpandIcon: boolean = false;
    captainVideoIcon: boolean = false;
    captainExpandIcon: boolean = false;
    expand: boolean = false;
    isZIndex: boolean = false;
    seeAll: boolean = false;
    reportList: boolean = false;
    reportTitle: string = "";
    ChatType: string = "";
    reportDummyElement: number = 0;
    crewChatDimension: crewChat = {
        height: 0,
        width: 0
    }

    // Reset Password
    passwordVisiblity: boolean = false;
    cPasswordVisiblity: boolean = false;

    // Initiate Medical Event State
    selectedPassengerId: number | null = null;
    passengerList:PassengerType[]=[];
    passengerList2:PassengerType[]=[];
    filterPassengerList:PassengerType[]=[];
    selectedCrew: string = "";
    selectedFlight: string = "";
    passengerName: string = "";
    passengerNameError: boolean = false;
    selectedAge: number | null = null;
    gender: string = "";
    passengerConscious: boolean = false;
    initiateMedicalSymptoms: initiateMedicalShow = {
        showSymptoms: false,
        filterEnable: false
    };
    flightList: [] = [];
    flightStoreList: [] = [];
    ageList: [] = [];
    crewList: [] = [];
    crewStoreList: [] = [];
    filterCrewList: [] = [];
    commonSymptompList = ['Nausea','Stomach Ache','Headache','Fever','Chest Pain','Shortness of Breath','Back Pain','Leg Pain','Chills','Ankle Sprain','Light Headedness',];
    otherSymptoms: string = "";
    otherSympInput: boolean = false;
    selectedSymptoms: string[] = [];
    passengerDetail: boolean = false;

    // Reset Password State
    password: string = "";
    confirmPassword: string = "";
    submitButtonEnable: boolean = false;
    resetPassError: string = "";
    isPassReset: string = "";
    rolelabel: string = "";
    errorText: string = "";
    createMedicalErrorText: string = "";

    // History State
    yearSelected: string = new Date().getFullYear().toString();
    monthSelected: string = new Date().getMonth().toString();
    selectedDate: string = new Date().toISOString();
    isDateSelected: boolean = false;
    medicalEmergencyWithPassengerList: MedicalEmergencyWithPassengerType[] = [];
    isYearSelctionShow: boolean = false;
    historySearchString: string = "";

    reportListModal: boolean = false;
    medicalEmergencyId: number | null = null;

    // Main page state
    notificationForInternetStatus: notificationForStatus = {
        notificationTitle: null,
        notificationMessage: null
    };
    notificationList: boolean = false;
    report: number = 1;
    // noteEdit: boolean = true;

    medicalKitId: number | null = null;
    update : number = 0;

 
    // passenger detail
    singlePassengerDetail: singlePassengerDetail | null = null;
    chronicDiseases: string = "";
    physicalDisableAns: string = "";
    someAdditionalPassengerDetail: any = Object;

    // user info
    user = null;

    selectedEmergency: IMedicalEmergencyApiResponse | null = null
    resolvedPopUp: boolean = false;

    orgList: OrganizationType[] = [];
    orgStoreList: OrganizationType[] = [];
    filterOrgList: OrganizationType[] = [];
    selectedOrgId: string = "";
    flightIdsLogged: { [key: string]: boolean } = {};

    medicalKitItems = [];
    selectedItems = [];
    
    rootStore: IRootStore;
 
    constructor(rootStore: IRootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    changeNetworkStatus = (status: boolean) => {
        this.networkStatus = status;
    }

    get getNetworkValue () {
        return this.networkStatus;
    }
    
    changePaths = async (paths: any[]) => {
        this.path = paths;
    }

    get getPaths() {
        return this.path;
    }
    
    handleNewEmergency = () => {
        this.newEmergency++;
    }

    get getNewEmergency() {
        return this.newEmergency
    }

    handleActiveTab = (tab: number) => {
        this.activeTab = tab;
    }

    get getActiveTab() {
        return this.activeTab;
    }

    handleAssignToMeModal = (value: boolean) => {
        this.assignToMeModal = value;
    }

    get getAssignToMeModal() {
        return this.assignToMeModal;
    }

    handleAssignToSomeoneModal = (value: boolean) => {
        this.assignToSomeoneModal = value;
    }

    get getAssignToSomeoneModal() {
        return this.assignToSomeoneModal;
    }

    handleAssignModal = (value: boolean) => {
        this.showAssignModal = value;
    }

    get getAssignedModal() {
        return this.showAssignModal;
    }

    handleSearchValue = (searchstring: string) => {
        this.searchValue = searchstring;
    }

    get getSearchString() {
        return this.searchValue;
    }
    get getEmsList() {
        return this.EmsList;
    }

    handleEmsSearchString = (val: string) => {
        this.emsSearchString = val;
    }

    get getemsSearchString() {
        return this.emsSearchString;
    }

    handleSelectEmsId = (id: string) => {
        this.selectedEmsId = id;
    }

    get getSelectedEmsId() {
        return this.selectedEmsId;
    }

    handleEmsListSearch = (searchString: string) => {
        this.searchEmsList = searchString;
    }

    get getEmsListSearch() {
        return this.searchEmsList;
    }

    handleStatusFilter = (inputVal: string) => {
        this.emergencyStatusFilter = inputVal;
    }

    get getStatusFilterValue() {
        return this.emergencyStatusFilter;
    }

    handleMedicalEmergecies(emergencyList: IMedicalEmergencyApiResponse[]) {
        this.medicalEmergencies = emergencyList;
    }

    get getEmergencies() {
        return this.medicalEmergencies;
    }

    handleSelectedMedicalIdList = (id: number, val: boolean) => {
        this.selectedMedicalIdList[id] = val;
    }

    resetSelectedMedicalIdList = () => {
        this.selectedMedicalIdList = {};
    }

    emptySelectedMedicalList = () => {
        this.selectedMedicalIdList = {};
    }

    get getSelectedMedicalList() {
        return this.selectedMedicalIdList;
    }

    handleSelectedMedicalIdListEms = (id: number, val: boolean) => {
        this.selectedMedicalIdListEms[id] = val;
    }

    resetSelectedMedicalIdListEms = () => {
        this.selectedMedicalIdListEms = {};
    }

    emptySelectedMedicalListEms = () => {
        this.selectedMedicalIdListEms = {};
    }

    get getSelectedMedicalListEms() {
        return this.selectedMedicalIdListEms;
    }
    
    handlePassengerIdNameMapState = (id: string, name: any) => {
        this.passengerIdNameMapState.set(id, name);
    }

    get getPassengerIdNameMapState() {
        return this.passengerIdNameMapState;
    }

    handleFlightRoomId = (id: string) => {
        this.flightRoom = id;
    }

    get getFlightRoomId() {
        return this.flightRoom;
    }

    handleNotes = (value: string) => {
        this.notes = value;
    }

    get getNotes() {
        return this.notes;
    }

    handleAllNotes = (key: string, value: string) => {
        let newObj = {[key]: value};
        this.allNotes = {...this.allNotes, ...newObj};
    }

    get getAllNotes() {
        return this.allNotes;
    }

    handleActiveNotes = (activeIndex: number) => {
        this.activeNotes = activeIndex;
    }
    get getActiveNotes() {
        return this.activeNotes;
    }
    handleFlightID = (id: string) => {
        this.flightId = id;
    }

    get getFlightId() {
        return this.flightId;
    }

    handleOnlineStatus = (status: boolean) => {
        this.onlineStatus = status;
    }

    get getOnlineStatus() {
        return this.onlineStatus;
    }

    handleDiversionStatus = (value: string) => {
        this.diversion = value;
    }

    get getDiversionStatus() {
        return this.diversion;
    }

    handleFlightLanded = (value: boolean) => {
        this.flightLanded = value;
    }

    get getFlightLandedStatus() {
        return this.flightLanded;
    }

    handlePageRefreshCount = (value: number) => {
        this.pageRefresh = value;
    }

    get getpageRefreshCount() {
        return this.pageRefresh;
    }

    handleMedicalKitRefresh = () => {
        this.medicalKitRefresh++;
    }

    get getMedicalKitRefresh() {
        return this.medicalKitRefresh;
    }

    handlePassenger = (data: PassengerType | null ) => {
        this.passenger = data;
    }

    get getPassenger() {
        return this.passenger;
    }

    handleResponsiveState = (value: boolean) => {
        this.responsiveState = {...this.responsiveState, showEmergencyDetails: value };
    }

    get getResponsiveState() {
        return this.responsiveState;
    }
    
    handleReportInticator = (keyName: string,value: boolean) => {
        this.reportIndicator = {...this.reportIndicator, [keyName]: value };
    }
    
    resetReportIndicator = () => {
        this.reportIndicator = { 
          glucoMeter: false,
          bloodPressure: false,
          oxiMeter: false,
          aed: false
        };
      }
      
    get getReportIndicator() {
        return this.reportIndicator;
    }

    setAllReportList = (list: []) => {
        this.allReportList = list;
    }
    get getAllReportList() {
        return this.allReportList;
    }
    resetAllReportList = () => {
        this.allReportList = [];
    }

    setFilterReportList = (fList: any) => {
        this.filterReportList = fList;
    }
    get getFilterReportList() {
        return this.filterReportList;
    }
    resetFilterReportList = () => {
        this.filterReportList = [];
    }

    setHistoryReporlList = (List: any) => {
        this.historyPageReportList = List;
    }
    get getHistoryReportList() {
        return this.historyPageReportList;
    }
    resetHistoryReportList = () => {
        this.historyPageReportList = [];
    }
    

    handleReportImageState = (obj: ReportImageStateType) => {
        this.reportImageState = obj;
    }

    get getReportImageState() {
        return this.reportImageState;
    }

    handleChatImageState = (obj: ReportImageStateType) => {
        this.chatImageState = obj;
    }

    get getChatImageState() {
        return this.chatImageState;
    }

    handleHistoryReportImageState = (obj: ReportImageStateType) => {
        this.reportHistoryImageState = obj;
    }

    get getHistoryReportImageState() {
        return this.reportHistoryImageState;
    }

    handleDialogState = (obj: DialogBoxType) => {
        this.dialogState = obj;
    }

    get getDialogState() {
        return this.dialogState;
    }

    handleVideoCallRecord = (data: VideocallResponseType | null) => {
        this.videocallRecord = data;
    }

    get getVideoCallRecord() {
        return this.videocallRecord;
    }

    handleEvents = (events: EventApiResponseType[]) => {
        this.event = events;
    }

    get getEvents() {
        return this.event;
    }

    get getFlightRecord() {
        return this.flightRecord;
    }

    setReportTopM = (mTop: number) => {
        this.reportCardTopM = mTop;
    }

    get getReportTopM() {
        return this.reportCardTopM;
    }

    setCrewVideoIcon = (isHover: boolean) => {
        this.crewVideoIcon = isHover
    }
    toggleCrewVideoCall = () => {
        this.crewVideoIcon = !this.crewVideoIcon;
    }
    get getCrewVideoIcon() {
        return this.crewVideoIcon;
    }

    setCrewAudioIcon = (isHover: boolean) => {
        this.crewAudioIcon = isHover
    }
    toggleCrewAudioCall = () => {
        this.crewAudioIcon = !this.crewAudioIcon;
    }
    get getCrewAudioIcon() {
        return this.crewAudioIcon;
    }

    setCrewExpandIcon = (isHover: boolean) => {
        this.crewExpandIcon = isHover
    }
    toggleCrewExpand = () => {
        this.crewExpandIcon = !this.crewExpandIcon;
    }
    get getCrewExpandIcon() {
        return this.crewExpandIcon;
    }

    setCaptainVideoIcon = (isHover: boolean) => {
        this.captainVideoIcon = isHover
    }
    toggleCaptainVideoCall = () => {
        this.captainVideoIcon = !this.captainVideoIcon;
    }
    get getCaptainVideoIcon() {
        return this.captainVideoIcon;
    }

    setCaptainExpandIcon = (isHover: boolean) => {
        this.captainExpandIcon = isHover
    }
    toggleCaptainExpand = () => {
        this.captainExpandIcon = !this.captainExpandIcon;
    }
    get getCaptainExpandIcon() {
        return this.captainExpandIcon;
    }

    setExpand = () => {
        this.expand = !this.expand;
    }
    get getExpand() {
        return this.expand;
    }

    setZIndex = () => {
        this.isZIndex = !this.isZIndex;
    }
    get getZIndex() {
        return this.isZIndex;
    }

    setCrewChat = (obj: crewChat) => {
        this.crewChatDimension = obj;
    }
    get getCrewChat() {
        return this.crewChatDimension;
    }

    setSeeAll = () => {
        this.seeAll = !this.seeAll;
    }
    get getSeeAll() {
        return this.seeAll;
    }
    resetSeeAll = () => {
        this.seeAll = false;
    }

    setReportList = () => {
        this.reportList = !this.reportList;
    }
    get getReportList() {
        return this.reportList;
    }
    resetReportList = () => {
        this.reportList = false;
    }

    setReportTitle = (title: string) => {
        this.reportTitle = title;
    }
    get getReportTitle() {
        return this.reportTitle;
    }
    
    setChatType = (type: string) => {
        this.ChatType = type;
    }
    get getChatType() {
        return this.ChatType;
    }

    setReportDElement = (h: number) => {
        this.reportDummyElement = h;
    }
    get getReportDElement() {
        return this.reportDummyElement;
    }

    // Reset Password State
    handlePassWordVisiblity = (val: boolean) => {
        this.passwordVisiblity = val;
    }
    get getPwdVisiblity() {
        return this.passwordVisiblity;
    }

    handleCPassWordVisiblity = (val: boolean) => {
        this.cPasswordVisiblity = val;
    }
    get getCPwdVisiblity() {
        return this.cPasswordVisiblity;
    }

    // Initiate Medical State
    handleSelectedPassengerId = (id: number | null) => {
        this.selectedPassengerId = id;
    }
    get getSelectedPassengerId() {
        return this.selectedPassengerId;
    }

    handlePassengerList = (passengers:   PassengerType[]) => {
        this.passengerList = passengers;
    }
    get getPassengerList() {
        return this.passengerList;
    }

    handlePassengerList2 = (passengers:   PassengerType[]) => {
        this.passengerList2 = passengers;
    }
    get getPassengerList2() {
        return this.passengerList2;
    }

    handleFilterPassengerList2 = (passengers:   PassengerType[]) => {
        this.filterPassengerList = passengers;
    }
    get getFilterPassengerList2() {
        return this.filterPassengerList;
    }
    
    handleSelectedCrew = (crew: string) => {
        this.selectedCrew = crew;
    }
    get getSelectedCrew() {
        return this.selectedCrew;
    }

    handleSelectedFlight = (flight: string) => {
        this.selectedFlight = flight;
    }
    get getSelectedFlight() {
        return this.selectedFlight;
    }

    handlePassengerName = (passenger: string) => {
        this.passengerName = passenger;
    }
    get getPassengerName() {
        return this.passengerName;
    }

    handlePassengerNameError = (value: boolean) => {
        this.passengerNameError = value;
    }

    get getPassengerNameError() {
        return this.passengerNameError;
    }

    handleSelectedAge = (age: number) => {
        this.selectedAge = age;
    }
    get getSelectedAge() {
        return this.selectedAge;
    }
    resetAge= () => {
        this.selectedAge = null;
    }

    handleSelectedGender = (gender: string) => {
        this.gender = gender;
    }
    get getSelectedGender() {
        return this.gender;
    }

    handlePassengerConscious = (isPassengerConscious: string) => {
        if (isPassengerConscious == "Yes") {
            this.passengerConscious = true;
        } else {
            this.passengerConscious = false;
        }
    }
    get getPassengerConscious() {
        return this.passengerConscious;
    }

    handleShowDetails = (obj: initiateMedicalShow) => {
        this.initiateMedicalSymptoms = obj;
    }
    get getShowDetail() {
        return this.initiateMedicalSymptoms;
    }

    get getFlightList() {
        return this.flightList;
    }

    get getFlightStoreList() {
        return this.flightStoreList;
    }
    get getAgeList() {
        return this.ageList;
    }

    get getCrewList() {
        return this.crewList;
    }

    get getCrewStoreList() {
        return this.crewStoreList;
    }

    get getFliteredCrewList() {
        return this.filterCrewList;
    }

    get getCommonSymptomsList() {
        return this.commonSymptompList;
    }

    handleOtherSymptoms = (other: string) => {
        this.otherSymptoms = other;
    }
    get getOtherSymp() {
        return this.otherSymptoms;
    }

    handleOtherSympInput = (showInput: boolean) => {
        this.otherSympInput = showInput;
    }
    get getOtherSympInput() {
        return this.otherSympInput;
    }

    handleSelectedSymptoms = (symp: string) => {
        if (this.selectedSymptoms.includes(symp)) {
            this.selectedSymptoms = this.selectedSymptoms.filter((a) => a !== symp);
        } else {
            this.selectedSymptoms = [...this.selectedSymptoms, symp];
        }
    }

    resetSymptom = () => {
        this.selectedSymptoms = [];
    }
    get getSelectedSymptoms() {
        return this.selectedSymptoms;
    }

    // Reset password state
    handlePassword = (password: string) => {
        this.password = password;
    }
    get getPassword() {
        return this.password;
    }

    handleConfirmPassword = (confirmpassword: string) => {
        this.confirmPassword = confirmpassword;
    }
    get getConfirmPassword() {
        return this.confirmPassword;
    }

    handleSubmitBtnEnable = (enable: boolean) => {
        this.submitButtonEnable = enable;
    }
    get getSubmitBtnEnable() {
        return this.submitButtonEnable;
    }

    handleResetPassError = (error: string) => {
        this.resetPassError = error;
    }
    get getResetPassError() {
        return this.resetPassError;
    }

    handleIsPassReset = (success: string) => {
        this.isPassReset = success;
    }
    get getIsPassReset() {
        return this.isPassReset;
    }

    handleErrorTxt = (eTxt: string) => {
        this.errorText = eTxt;
    }
    get getErrorTxt() {
        return this.errorText;
    }

    handleCreateMedicalErrorTxt = (eTxt: string) => {
        this.createMedicalErrorText = eTxt;
    }
    get getCreateMedicalErrorTxt() {
        return this.createMedicalErrorText;
    }

    // History page State
    setYearSelected(year: string) {
        this.yearSelected = year;
      }
    get getSelectedYear() {
        return this.yearSelected
    }

    setMonthSelected(month: string) {
        this.monthSelected = month;
      }
    get getSelectedMonth() {
        return this.monthSelected
    }
    
    setSelectedDate(date: string) {
        this.selectedDate = date;
      }
    get getSelectedDate() {
        return this.selectedDate
    }

    handleMedicalListWithPassengername = async (username: string) => {
        let list = await MedicalEmergencyService.listMedicalEmergencyWithPassengersByEms(
            username
          );
        this.medicalEmergencyWithPassengerList = list;
    }

    get getMedicalListWithPassengername() {
        return this.medicalEmergencyWithPassengerList;
    }

    handleYearSelectionShow = () => {
        this.isYearSelctionShow = !this.isYearSelctionShow;
    }

    get getYearSelection() {
        return this.isYearSelctionShow;
    }

    handleIsDateSelect = () => {
        this.isDateSelected = true;
    }
    get getIsDateSelected() {
        return this.isDateSelected;
    }
    resetDateSelect = () => {
        this.isDateSelected = false;
    }

    handleSearchString(str: string){
        this.historySearchString = str;
    }

    get getHistorySearchString() {
        return this.historySearchString;
    }

    handleReportModal = () => {
        this.reportListModal = !this.reportListModal;
    }

    get getReportModal() {
        return this.reportListModal;
    }

    resetReportModal = () => {
        this.reportListModal = false;
    }

    handleMedicalId = (id: number) => {
        this.medicalEmergencyId = id;
    }
    get getEmergencyId() {
        return this.medicalEmergencyId;
    }

    // Main State
    handleNotificationTitleandMeg = (obj: notificationForStatus) => {
        this.notificationForInternetStatus = obj;
    }
    get getNotificationTitleandMsg() {
        return this.notificationForInternetStatus;
    }

    handleNotificationList = (isNewNotification: boolean) => {
        this.notificationList = isNewNotification;
    }
    get getNotificationList() {
        return this.notificationList;
    }

    handleReport = () => {
        this.report++;
    }
    get getReportCount() {
        return this.report;
    }


    handleSelectedEmergency = (emergency: IMedicalEmergencyApiResponse | null) => {
        this.selectedEmergency = emergency;
    }
    get getSelectedEmergency() {
        return this.selectedEmergency;
    }

    handleResolvedPopUp = (val: boolean) => {
        this.resolvedPopUp = val;
    }
    get getResolvedPopUp() {
        return this.resolvedPopUp;
    }

    // handleEditNotes = () => {
    //     this.noteEdit = !this.noteEdit;
    // }
    // get getEditNote() {
    //     return this.noteEdit;
    // }

    handleOrgList = (orgList: OrganizationType[]) => {
        this.orgList = orgList;
    }
    get getOrgList() {
        return this.orgList;
    }

    handleRoleLabel = (label: string) => {
        this.rolelabel = label;
    }
    get getRoleLabel() {
        return this.rolelabel;
    }
    handleOrgStoreList = (orgList: OrganizationType[]) => {
        this.orgStoreList = orgList;
    }
    get getOrgStoreList() {
        return this.orgStoreList;
    }

    handleFilterOrgList = (orgList: OrganizationType[]) => {
        this.filterOrgList = orgList;
    }
    get getFilterOrgList() {
        return this.filterOrgList;
    }

    handleSelectedOrgId = (orgId: string) => {
        this.selectedOrgId = orgId;
    }
    get getSelectedOrgId() {
        return this.selectedOrgId;
    }

    handlePassengerDetail = (val: boolean) => {
        this.passengerDetail = val;
    }
    get getPassengerDetail() {
        return this.passengerDetail;
    }

    handleFlightsubscribe = (flightId:string) => {
        this.flightIdsLogged[flightId] = true;
    }

    get getFlightsubscribe() {
        return this.flightIdsLogged;
    }

    resetFlightsubscribe = () => {
        this.flightIdsLogged = {}; 
      };
      handlemedicallist(list : any){
        this.historySearchString = list;
    }

    get getmedicallist(){
       return this.historySearchString;
    }
    
    setMedicalKitId = (id: number) => {
        this.medicalKitId = id;
    }
    get getMedicalKitId() {
        return this.medicalKitId;
    }
    handleupdate = () => {
        this.update++;
    }
    get getupdate () {
        return this.update ;
    }

    setSinglePassengerDetail = (detail: singlePassengerDetail) => {
        this.singlePassengerDetail = detail;
    }
    get getSinglePassengerDetail() {
        return this.singlePassengerDetail;
    }

    handleCronicDieses = (arg: string) => {
        this.chronicDiseases = arg;
    }
    get getCronicDiseases() {
        return this.chronicDiseases;
    }

    handlePhysicalDisableAns = (arg: string) => {
        this.physicalDisableAns = arg;
    }
    get getPhysicalDisableAns() {
        return this.physicalDisableAns;
    }

    handleKitItem = (item: any) => {
        this.medicalKitItems = item;
    }
    get getKitItem() {
        return this.medicalKitItems;
    }

    handleKitSelectedItem = (item: any) => {
        this.selectedItems = item;
      }
      get getKitSelectedItem() {
        return this.selectedItems;
      }
}